<template>
  <div
    id="print-area"
    ref="printArea"
    style="display: none; display: flex; justify-content: space-between;"
  >
    <div
      class="nota"
    >
      <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-bottom: 10px;">
        <div style="text-align: center;">
          <div
            style="margin: 0;"
            class="logo-wrapper"
          >
            <logo />
          </div>

          <h2>
            SURAT PERINTAH KERJA
          </h2>
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div style="font-family: monospace; font-size: 10px; width: 100%; margin: 0; margin-top: 4px; margin-bottom: 3px;">
          <div style="display: flex; justify-content: space-between; margin-bottom: 5px;">
            <span>Kategori</span>
            <span> &nbsp;{{ data.ctg }}</span>
          </div>
          <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
        </div>

        <div
          v-for="item in data.list"
          :key="item.id"
          style="margin-bottom: 6px;"
        >
          <div style="margin-bottom: 2px;">
            <div style="width: 100%;">
              <b>{{ item.product }}</b>
            </div>
            <div style="display: flex; flex-wrap: wrap; font-size: 10px;">
              <div style="width: 100%;">
                No {{ (item.trx_no) }}
              </div>
              <div style="width: 30%;">
                QTY @{{ (item.qty) }}
              </div>
              <div class="100%">
                P X L ({{ item.size }})
              </div>
              <div style="width: 100%;">
                File : {{ item.file }}
              </div>
              <div style="width: 100%;">
                Finishing : {{ item.finishing }}
              </div>
              <div style="width: 100%;">
                Catatan : {{ item.desc }}
              </div>
            </div>
            <div style="width: 100%;">
              <hr style="border: none; border-top: 1px dashed #000; margin: 5px 0;">
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import Logo from '@core/layouts/components/Logo.vue'

export default {
  components: {
    Logo,
  },
  props: {
    data: Object,
  },
  data() {
    return {
    }
  },
  methods: {
    print() {
      const printContents = this.$refs.printArea.innerHTML
      const w = window.open('', '', '')
      w.document.write(`
      <html>
        <head>
          <style>
            @media print {
              @page {
                size: 58mm auto;
                margin: 0;
              }
              body {
                font-family: monospace;
                font-size: 10px;
                margin: 0;
                padding: 5px;
              }
              .center { text-align: center; }
              tr {font-size: 10px; }
              hr { border: dashed 1px black; }
              .logo-wrapper img {
                max-width: 100%;
                height: auto;
                display: inline-block;
                max-width: 200px;
                margin-bottom: 40px;
                margin-top: 20px;
              }
            }
          </style>
        </head>
        <body onload="window.print();window.close(); ">
          ${printContents}
        </body>
      </html>
    `)
      w.document.close()
    },

  },
}
</script>
